module.exports = __webpack_public_path__ + "static/media/2022 - 23 Simone Kong-min.84b105e0.jpg";